import { useCallback } from 'react';

import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useUnarchiveConversation } from '@web/conversations/hooks/useUnarchiveConversation';

type Props = {
  id: number;
};

export const useUnarchiveConversationAction = () => {
  const mutation = useUnarchiveConversation();
  const { unarchiveConversation } = useConversationActions();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async ({ id }: Props) => {
      try {
        await mutateAsync({ id });

        unarchiveConversation({ id });
      } finally {
        // INFO we don't care about the result for some reason ;)
      }
    },
    [mutateAsync, unarchiveConversation]
  );

  return { action, mutation };
};
